var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text0, _text1, _text10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandscape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 340,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f9f5f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f2ede8"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 340,
    fill: "url(#bg)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 24,
    x2: 56,
    y2: 296,
    stroke: "#e8e2dc",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 296,
    x2: 572,
    y2: 296,
    stroke: "#e8e2dc",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 228,
    x2: 572,
    y2: 228,
    stroke: "#ede8e2",
    strokeWidth: 0.7,
    strokeDasharray: "5 4"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 160,
    x2: 572,
    y2: 160,
    stroke: "#ede8e2",
    strokeWidth: 0.7,
    strokeDasharray: "5 4"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 92,
    x2: 572,
    y2: 92,
    stroke: "#ede8e2",
    strokeWidth: 0.7,
    strokeDasharray: "5 4"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 24,
    x2: 185,
    y2: 296,
    stroke: "#ede8e2",
    strokeWidth: 0.7,
    strokeDasharray: "5 4"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 315,
    y1: 24,
    x2: 315,
    y2: 296,
    stroke: "#ede8e2",
    strokeWidth: 0.7,
    strokeDasharray: "5 4"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 445,
    y1: 24,
    x2: 445,
    y2: 296,
    stroke: "#ede8e2",
    strokeWidth: 0.7,
    strokeDasharray: "5 4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 548,
    cy: 68,
    r: 38,
    fill: "#1a1a2e",
    opacity: 0.72
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 95,
    r: 24,
    fill: "#1a1a2e",
    opacity: 0.65
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 118,
    r: 16,
    fill: "#1a1a2e",
    opacity: 0.55
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 138,
    r: 11,
    fill: "#1a1a2e",
    opacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 58,
    r: 20,
    fill: "#dc2626",
    opacity: 0.78
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 72,
    r: 15,
    fill: "#dc2626",
    opacity: 0.72
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 84,
    r: 12,
    fill: "#dc2626",
    opacity: 0.68
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 96,
    r: 10,
    fill: "#dc2626",
    opacity: 0.65
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 110,
    r: 8,
    fill: "#dc2626",
    opacity: 0.6
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 155,
    r: 22,
    fill: "#059669",
    opacity: 0.7
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 170,
    r: 14,
    fill: "#059669",
    opacity: 0.65
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 148,
    r: 9,
    fill: "#059669",
    opacity: 0.68
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 130,
    r: 7,
    fill: "#059669",
    opacity: 0.62
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 510,
    cy: 200,
    r: 28,
    fill: "#7c3aed",
    opacity: 0.62
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 440,
    cy: 190,
    r: 19,
    fill: "#7c3aed",
    opacity: 0.58
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 185,
    r: 11,
    fill: "#7c3aed",
    opacity: 0.6
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 195,
    r: 10,
    fill: "#4f46e5",
    opacity: 0.7
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 210,
    r: 8,
    fill: "#4f46e5",
    opacity: 0.65
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 222,
    r: 7,
    fill: "#4f46e5",
    opacity: 0.6
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 168,
    r: 9,
    fill: "#0891b2",
    opacity: 0.68
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 185,
    r: 5,
    fill: "#0891b2",
    opacity: 0.6
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 148,
    r: 9,
    fill: "#d97706",
    opacity: 0.68
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 162,
    r: 7,
    fill: "#d97706",
    opacity: 0.62
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 148,
    r: 5,
    fill: "#d97706",
    opacity: 0.55
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 314,
    y: 322,
    textAnchor: "middle",
    fill: "#c0b8b0",
    fontSize: 11,
    fontFamily: "Inter, sans-serif",
    letterSpacing: 0.3
  }, "Total Funding Raised (log scale)")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 165,
    textAnchor: "middle",
    fill: "#c0b8b0",
    fontSize: 11,
    fontFamily: "Inter, sans-serif",
    letterSpacing: 0.3,
    transform: "rotate(-90,30,165)"
  }, "Val / Funding Multiple")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 312,
    textAnchor: "middle",
    fill: "#ccc",
    fontSize: 9,
    fontFamily: "Inter, sans-serif"
  }, "$20M")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 185,
    y: 312,
    textAnchor: "middle",
    fill: "#ccc",
    fontSize: 9,
    fontFamily: "Inter, sans-serif"
  }, "$500M")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 315,
    y: 312,
    textAnchor: "middle",
    fill: "#ccc",
    fontSize: 9,
    fontFamily: "Inter, sans-serif"
  }, "$5B")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 445,
    y: 312,
    textAnchor: "middle",
    fill: "#ccc",
    fontSize: 9,
    fontFamily: "Inter, sans-serif"
  }, "$50B")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 572,
    y: 312,
    textAnchor: "middle",
    fill: "#ccc",
    fontSize: 9,
    fontFamily: "Inter, sans-serif"
  }, "$250B")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 299,
    textAnchor: "end",
    fill: "#ccc",
    fontSize: 9,
    fontFamily: "Inter, sans-serif"
  }, "0x")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 231,
    textAnchor: "end",
    fill: "#ccc",
    fontSize: 9,
    fontFamily: "Inter, sans-serif"
  }, "5x")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 163,
    textAnchor: "end",
    fill: "#ccc",
    fontSize: 9,
    fontFamily: "Inter, sans-serif"
  }, "10x")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 95,
    textAnchor: "end",
    fill: "#ccc",
    fontSize: 9,
    fontFamily: "Inter, sans-serif"
  }, "15x")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 572,
    y: 20,
    textAnchor: "end",
    fill: "#bbb",
    fontSize: 10,
    fontFamily: "JetBrains Mono, monospace"
  }, "41 companies \xB7 Q1 2026")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandscape);
export default __webpack_public_path__ + "static/media/landscape.e72c6516f531460b51118781da80bbc4.svg";
export { ForwardRef as ReactComponent };